module.exports = __webpack_public_path__ + "img/1F1F7-1F1FC.4799be52.svg";